import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfiguracionInicialService } from './configuracioninicial.service';
import { UtilitariosService } from './utilitarios.service';
import { Constantes } from '../models/modules/Constantes';
import { Observable } from 'rxjs/internal/Observable';
import { AutenticacionToken } from '../models/generic/AutenticacionToken';
import { UsuarioRetornoAutenticacion } from '../models/generic/UsuarioRetornoAutenticacion';
import { UsuarioDatos } from '../models/generic/UsuarioDatos';
import { UsuarioRefrescarToken } from '../models/generic/UsuarioValidacion';
import { observable, timer } from 'rxjs';
import { UsuarioValidacion } from '../models/generic/UsuarioRefrescarToken';
import { Canales } from '../models/generic/Canales';
import { HeaderDatos } from '../models/generic/HeaderDatos';
import { DatosStorage } from '../models/generic/DatosStorage';

@Injectable({
  providedIn: 'root'
})
export class AutenticacionService {
  TokenAcceso: string;
  FechaExpiracion: Date;
  Recaptcha: string;
  UsuarioActivo: UsuarioDatos;
  AplicacionSeleccionado: number = 0;
  AliadoSeleccionado: number = 0;
  DescripcionAliadoSeleccionado: string = '';
  ListaCanales: Canales[] = [];
  CanalSeleccionado: number = 0;
  DescripcionCanalSeleccionado: string = '';
  RolMulticonsulta: boolean = false;
  RolEditarProductoCliente: boolean = false;
  RolEliminarProductoCliente: boolean = false;
  MostrarSedeconsulta: boolean = false;
  Componente: string = '';

  AplicacionSeleccionadoInicial: number = 0;
  AliadoSeleccionadoInicial: number = 0;
  DescripcionAliadoSeleccionadoInicial: string = '';
  CanalSeleccionadoInicial: number = 0;
  DescripcionCanalSeleccionadoInicial: string = '';
  
  constructor(private httpClient: HttpClient,
    private configInicial: ConfiguracionInicialService,
    private utilitarios: UtilitariosService) {
      this.IniciarTimer();
  }

  EstaAutenticado(): boolean {
    return this.utilitarios.VerificarContieneDatos(this.UsuarioActivo);
  }

  LimpiarUsuario() {
    this.UsuarioActivo = null;
    this.AliadoSeleccionado = 0;
    this.DescripcionAliadoSeleccionado = '';
    this.CanalSeleccionado = 0;
    this.DescripcionCanalSeleccionado = '';
    this.utilitarios.LocalStorage_Eliminar(Constantes.STORAGE_DATOS());
  }
  
  ObtenerTokenAutorizacion(): Observable<AutenticacionToken> {
    let urlServicioToken: string = `${this.configInicial.ConfigLocal.UrlIdentityServer}${Constantes.TOKEN_SOLICITAR()}`;
    let parametrosAutenticacion: string = `client_id=${this.configInicial.ConfigLocal.ClientId}&client_secret=${encodeURIComponent(this.configInicial.ConfigLocal.ClientIdSecret)}&scope=${this.configInicial.ConfigLocal.ScopeAuth}&grant_type=${Constantes.GRANT_TYPE()}`;

    return this.PostToken(urlServicioToken, parametrosAutenticacion);
  }

  ValidarAccesoUsuario(nombreUsuario: string, clave: string, ipPublica: string): Observable<UsuarioRetornoAutenticacion> {
    let urlServicioToken: string = `${this.configInicial.ConfigLocal.UrlServicioAutorizacion}${Constantes.USUARIO_VERIFICAR()}`;
    let parametrosAutenticacion: UsuarioValidacion = new UsuarioValidacion();
    parametrosAutenticacion.usuario = nombreUsuario;
    parametrosAutenticacion.clave = clave;
    parametrosAutenticacion.ipPublica = ipPublica;

    return this.PostAutorizacion(urlServicioToken, parametrosAutenticacion, this.TokenAcceso, this.Recaptcha, nombreUsuario);
  }

  RefrescarTokenAccesoUsuario(): Observable<AutenticacionToken> {
    if (this.utilitarios.VerificarContieneDatos(this.UsuarioActivo)) {
      let urlServicioToken: string = `${this.configInicial.ConfigLocal.UrlServicioAutorizacion}${Constantes.USUARIO_REFRESCAR()}`;
      let parametrosAutenticacion: UsuarioRefrescarToken = new UsuarioRefrescarToken();
      parametrosAutenticacion.usuario = this.UsuarioActivo.nombre;
      parametrosAutenticacion.access_token = this.TokenAcceso;
      return this.PostAutorizacion(urlServicioToken, parametrosAutenticacion, this.TokenAcceso, this.Recaptcha, this.UsuarioActivo.nombre);
    }
    return new Observable<AutenticacionToken>();
  }

  PostToken(rutaWebApi: string, parametro: any) : Observable<any> {
    let header = new HttpHeaders({
      'Content-Type' : 'application/x-www-form-urlencoded'
      }
    );
    return this.httpClient.post<any>(rutaWebApi, parametro, { headers: header });
  }

  PostAutorizacion(rutaWebApi: string, parametro: any, tokenHeader: string = '', recaptcha: string, usuario: string) : Observable<any> {
    let usuarioHeader: HeaderDatos = new HeaderDatos();
    usuarioHeader.usuario = usuario;
    usuarioHeader.recaptcha = recaptcha;

    let header = new HttpHeaders({
      'Authorization' : Constantes.TIPO_AUTENTICACION() + ' ' + tokenHeader,
      'AuthorizationAdditional': JSON.stringify(usuarioHeader)
      }
    );
    return this.httpClient.post<any>(rutaWebApi, parametro, { headers: header});
  }

  IniciarTimer() {
    if (this.EstaAutenticado()) {
      if (this.utilitarios.VerificarContieneDatos(this.configInicial.ConfigLocal)) {
        const source = timer(this.configInicial.ConfigLocal.TiempoRefrescarToken, this.configInicial.ConfigLocal.TiempoRefrescarToken);
        const abc = source.subscribe(val => {
          this.RefrescarTokenUsuario();
        });
      }
    }
  }

  RefrescarTokenUsuario() {
    this.RefrescarTokenAccesoUsuario().subscribe((resp: AutenticacionToken) => {
      if (this.utilitarios.VerificarContieneDatos(resp)) {
        this.TokenAcceso = resp.access_token;
        this.FechaExpiracion = resp.expire; 
        this.AlmacenarInformacionStorage();
      }
    });
  }

  AlmacenarInformacionStorage() {
    let datosStorage: DatosStorage = new DatosStorage();
    datosStorage.TokenAcceso = this.TokenAcceso;
    datosStorage.FechaExpiracion = this.FechaExpiracion;
    datosStorage.Recaptcha = this.Recaptcha;
    datosStorage.UsuarioActivo = this.UsuarioActivo;
    datosStorage.AplicacionSeleccionado = this.AplicacionSeleccionado;
    datosStorage.AliadoSeleccionado = this.AliadoSeleccionado;
    datosStorage.DescripcionAliadoSeleccionado = this.DescripcionAliadoSeleccionado;
    datosStorage.ListaCanales = this.ListaCanales;
    datosStorage.CanalSeleccionado = this.CanalSeleccionado;
    datosStorage.DescripcionCanalSeleccionado = this.DescripcionCanalSeleccionado;
    datosStorage.RolMulticonsulta = this.RolMulticonsulta;
    datosStorage.RolEditarProductoCliente = this.RolEditarProductoCliente;
    datosStorage.RolEliminarProductoCliente = this.RolEliminarProductoCliente;
    datosStorage.MostrarSedeconsulta = this.MostrarSedeconsulta;
    datosStorage.Componente = this.Componente;
    datosStorage.AplicacionSeleccionadoInicial = this.AplicacionSeleccionadoInicial;
    datosStorage.AliadoSeleccionadoInicial = this.AliadoSeleccionadoInicial;
    datosStorage.DescripcionAliadoSeleccionadoInicial = this.DescripcionAliadoSeleccionadoInicial;
    datosStorage.CanalSeleccionadoInicial = this.CanalSeleccionadoInicial;
    datosStorage.DescripcionCanalSeleccionadoInicial = this.DescripcionCanalSeleccionadoInicial;

    this.utilitarios.LocalStorage_Grabar(Constantes.STORAGE_DATOS(), JSON.stringify(datosStorage));
  }

  VerificarInformacionStorage() {
    let informacionStorage = this.utilitarios.LocalStorage_Obtener(Constantes.STORAGE_DATOS());
    if (this.utilitarios.VerificarContieneDatosTexto(informacionStorage)) {
      let datosStorage: DatosStorage = JSON.parse(informacionStorage);
      if (this.utilitarios.VerificarContieneDatos(datosStorage)) {
        let fechaExpiracion = new Date(datosStorage.FechaExpiracion.toString()).getTime();
        let fechaActual = new Date().getTime();
        if (fechaExpiracion > fechaActual) {
          this.TokenAcceso = datosStorage.TokenAcceso;
          this.Recaptcha = datosStorage.Recaptcha;
          this.UsuarioActivo = datosStorage.UsuarioActivo;
          this.AplicacionSeleccionado = datosStorage.AplicacionSeleccionado;
          this.AliadoSeleccionado = datosStorage.AliadoSeleccionado;
          this.DescripcionAliadoSeleccionado = datosStorage.DescripcionAliadoSeleccionado;
          this.ListaCanales = datosStorage.ListaCanales;
          this.CanalSeleccionado = datosStorage.CanalSeleccionado;
          this.DescripcionCanalSeleccionado = datosStorage.DescripcionCanalSeleccionado;
          this.RolMulticonsulta = datosStorage.RolMulticonsulta;
          this.RolEditarProductoCliente = datosStorage.RolEditarProductoCliente;
          this.RolEliminarProductoCliente = datosStorage.RolEliminarProductoCliente;
          this.MostrarSedeconsulta = datosStorage.MostrarSedeconsulta;
          this.Componente = datosStorage.Componente;
          this.AplicacionSeleccionadoInicial = datosStorage.AplicacionSeleccionadoInicial;
          this.AliadoSeleccionadoInicial = datosStorage.AliadoSeleccionadoInicial;
          this.DescripcionAliadoSeleccionadoInicial = datosStorage.DescripcionAliadoSeleccionadoInicial;
          this.CanalSeleccionadoInicial = datosStorage.CanalSeleccionadoInicial;
          this.DescripcionCanalSeleccionadoInicial = datosStorage.DescripcionCanalSeleccionadoInicial;
        } else {
          this.utilitarios.LocalStorage_Eliminar(Constantes.STORAGE_DATOS());
        }
      }
    }
  }
}
